
<h1 class="titulo">Beneficiarios Gestantes</h1>
<nz-spin [nzSpinning]="loading" nzTip="Cargando..." class="loading-spinner">
<div class="boton-añadir-container" *ngIf="this.user?.esRRHH || this.user?.esAdmin  || this.user?.esMedico">
  <button
    *ngIf="NoAcceso"
    nz-button
    nzType="primary"
    class="excel-button boton-añadir"
    (click)="AddBeneficiario()"
  >
    <i nz-icon nzType="plus" nzTheme="outline"></i>
    Añadir Solicitud de Bebé Gestante
  </button>
</div>
<div class="tabla-principal">
  <div class="tabla-header-container">
    <div class="tabla-header-left">
      <span class="registros-label"
        >Registros: <strong>{{ beneficiariosFiltrados?.length }}</strong></span
      >
    </div>
  </div>

  <div class="search-container search-input-full">
    <nz-input-group nzSuffixIcon="search" class="">
      <input
        type="text"
        nz-input
        placeholder="Buscar por nombre, apellido o parentesco.."
        [(ngModel)]="searchText"
        (ngModelChange)="onSearchChange($event)"
      />
    </nz-input-group>
  </div>

  <nz-spin [nzSpinning]="loading">
  <nz-table
    #basicTable
    [nzData]="beneficiariosFiltrados || []"
    class="tabla-colaboradores"
    [nzScroll]="{ x: '1400px' }"
  >
    <thead>
      <tr>
        <th class="accions-icon"></th>
        <th class="bold ">Colaborador</th>
        <th class="bold">Género</th>
        <th class="bold">Beneficiario</th>
        <th class="bold">Fecha Inicio</th>
        <th class="bold">Fecha Fin</th>
        <th class="bold">Tipo Gestación</th>
        <th class="bold">Estado</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let beneficiario of basicTable.data">
        <td>
          <div class="acciones-container">
            <img
                  src="assets/icon/detail-sgmm.svg"
                  class="icono-sgmm"
                  style="cursor: pointer;"
                  alt="icono sgmm"
                  (click)="verDetalles(beneficiario)"
                />
          </div>
        </td>
        <td class="row">{{ (beneficiario.colaboradorNombre || '') + ' ' + (beneficiario.colaboradorApellidos || '') }}</td>
        <td class="row">
          <nz-tag [nzColor]="beneficiario.colaboradorGenero === 'M' ? 'blue' : 'pink'">
            {{ beneficiario.colaboradorGenero === 'M' ? "Masculino" : "Femenino" }}
          </nz-tag>
        </td>
        <td class="row">{{ (beneficiario?.tipoGestacionId == 1) ? ( '-' ) : (beneficiario.beneficiarioNombre || 'N/A') }}</td>
        <td class="row">{{ beneficiario.fechaInicio | date : "dd/MM/yyyy" }}</td>
        <td class="row">{{ beneficiario.fechaFin | date : "dd/MM/yyyy" }}</td>
        <td class="row">
          <nz-tag [nzColor]="beneficiario.tipoGestacion === 'Personal' ? 'green' : 'orange'">
            {{ beneficiario.tipoGestacion || 'N/A' }}
          </nz-tag>
        </td>
        <td class="row">
          <nz-tag [nzColor]="getColor(beneficiario.estadoGestacion!)">
            {{ beneficiario.estadoGestacion || 'N/A' }}
          </nz-tag>
        </td>
      </tr>
    </tbody>
  </nz-table>
     <nz-modal [(nzVisible)]="isVisible" nzTitle="Baja del beneficio" (nzOnCancel)="Cancel()">
      <div *nzModalContent>
        <div>
          <p style="margin-bottom: 15px; font-weight: 500;">Por favor seleccione la fecha de finalización del beneficio:</p>
          <nz-date-picker 
            [(ngModel)]="fechaFinalizacion"
            nzFormat="yyyy-MM-dd"
            nzPlaceHolder="Seleccionar fecha de finalización"
            [nzAllowClear]="false"
            [nzDisabledDate]="disabledDate"
            style="width: 100%;"
            >
          </nz-date-picker>

          
        </div>
      </div>
      <div *nzModalFooter>
        <button nz-button class="excel-button boton-añadir flex end" nzType="primary" (click)="confirmarBajaBeneficiario()" [nzLoading]="isConfirmLoading">Aceptar</button>
      </div>
    </nz-modal>
  </nz-spin>
</div>
</nz-spin>